/* eslint-disable babel/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import * as React from "react";
import styled from "styled-components";
import { useTracking } from "@origin-digital/ods-core";

interface IOption {
  value: string;
  label: string;
}

export interface SelectElementProps {
  selectedValue?: string;
  options: IOption[];
  onChange?: React.ChangeEventHandler<HTMLSelectElement>;
  hidden?: boolean;
  width?: number;
  "data-id"?: string;
}

const SelectElement = styled.select<Partial<SelectElementProps>>`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: "gordita", sans-serif;
  color: ${(p) => p.theme.colors.grey400};
  border: 0;
  font-size: 12px;
  outline: none;
  background: transparent;
  appearance: none;
  border-radius: 0;
  margin: 0;
  display: block;
  cursor: pointer;
  width: ${({ hidden }) => (hidden ? "0" : "100%")};
  max-width: 100%;
  margin-right: ${({ hidden }) => (hidden ? "-40" : "-20")}px;
  padding-right: ${({ hidden }) => (hidden ? "40" : "20")}px;
  height: 44px;
  @media (min-width: ${(p) => p.theme.breakpoints.lg}) {
    width: ${({ width }) => (width ? `${width + 22}px` : "100%")};
  }
`;

export const Select: React.SFC<SelectElementProps> = (props) => {
  const {
    hidden,
    onChange,
    options,
    width,
    selectedValue,
    "data-id": dataId,
  } = props;

  const { onClickCapture } = useTracking({
    children: selectedValue,
    "data-id": dataId || "property-selector",
    type: hidden ? "compact" : "full",
  });

  const handleOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onClickCapture?.();
    onChange?.(e);
  };

  return (
    <SelectElement
      data-id={dataId}
      width={width}
      onChange={handleOnChange}
      value={selectedValue}
      hidden={hidden}
    >
      {options?.map(({ label, value }, ix) => (
        <option value={value} key={value || `Select${ix}`}>
          {label}
        </option>
      ))}
    </SelectElement>
  );
};
